import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IAPIState, IStatus } from "shared/types";
import { EquipmentCategoryForm } from "Venues/components";
import { useStagePageContext } from "Venues/contexts";
import { clearActionMeta, dataMetaSelector } from "Venues/state";
import {
  IEquipmentSubcategoryItem,
  IStageEquipmentCategory,
} from "Venues/types";
import {
  getEquipmentCategoriesKey,
  useClearActionMetaOnUnMount,
} from "Venues/utils";

import { copy } from "shared/assets";
import { addTemporaryToast } from "shared/components/Toast";

interface EditSubcategoryProps {
  category: IEquipmentSubcategoryItem;
  handleCategorySubmit: (data: IStageEquipmentCategory) => void;
  closeForm?: () => void;
}

export const EditSubcategory: React.FC<EditSubcategoryProps> = ({
  category,
  handleCategorySubmit,
  closeForm,
}) => {
  const dispatch = useDispatch();
  const { stageId } = useStagePageContext();
  const metaUrl = useMemo(
    () => getEquipmentCategoriesKey(stageId, category?.category || ""),
    [stageId, category]
  );
  const { api: categoryApiMeta } = useSelector(dataMetaSelector(metaUrl));
  useClearActionMetaOnUnMount(metaUrl);

  useEffect(() => {
    if (categoryApiMeta?.status === IAPIState.succeeded) {
      dispatch(clearActionMeta(metaUrl));
      dispatch(
        addTemporaryToast({
          message: copy.toast.changed,
          status: IStatus.success,
        })
      );
    }
  }, [categoryApiMeta, dispatch, metaUrl]);

  return (
    <EquipmentCategoryForm
      category={category}
      hasError={!!categoryApiMeta?.error}
      apiStatus={categoryApiMeta?.status}
      handleSubmit={handleCategorySubmit}
      closeForm={closeForm}
    />
  );
};
